<template>
  <FreeBottomSheet :name="name" @onOpen="getFareRules">
    <template #header="{ hide }">
      <FreeHeader class="p-4">
        <template #default>
          <h2 class="text-text-neutral-primary text-base font-medium">
            {{ t('contacts.refundExchangeRules.title') }}
          </h2>
        </template>
        <template #rightAction>
          <FreeCloseButton @click="hide" />
        </template>
      </FreeHeader>
    </template>
    <template #default>
      <div
        v-if="isLoading"
        class="flex min-h-[80vh] items-center justify-center"
      >
        <FreeLoader class="green-spinner" />
      </div>
      <div v-else-if="fareRules" class="space-y-4 px-4 pb-4 text-base">
        <RulesList
          v-for="(flight, idx) in fareRules"
          :key="idx"
          class="bg-background-neutral-secondary rounded-xl p-4"
          :flight="flight"
        />
      </div>
    </template>
  </FreeBottomSheet>
</template>

<script setup lang="ts">
  import {
    FreeBottomSheet,
    FreeCloseButton,
    FreeHeader,
    FreeLoader,
  } from 'freedom-shared';
  import { useI18n } from 'vue-i18n';
  import { exchangeReturnPolicyEntity } from 'shared';

  import { fetchFareRules } from '@/shared/api';

  import RulesList from './RulesList.vue';

  const props = defineProps<{
    name: string;
    offerId: string;
  }>();

  const { fareRules, isLoading, getFareRules } =
    exchangeReturnPolicyEntity.model.useExchangeReturnPolicy(
      fetchFareRules,
      props.offerId,
    );

  const { t } = useI18n();
</script>
